var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"large":"","color":"primary"},on:{"click":function($event){return _vm.$emit('save')}}},[_vm._v("Salvar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }